import { render, staticRenderFns } from "./ReturnToPlanListButton.vue?vue&type=template&id=2fef9af6&scoped=true&"
import script from "./ReturnToPlanListButton.vue?vue&type=script&lang=ts&"
export * from "./ReturnToPlanListButton.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnToPlanListButton.vue?vue&type=style&index=0&id=2fef9af6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef9af6",
  null
  
)

export default component.exports